export const BASE_COLOR_VARS = {
  // Background Colors
  background: '--color-background',
  //Surface Colors
  'surface-card': '--color-surface-card',
  'surface-1': '--color-surface-1',
  'surface-2': '--color-surface-2',
  'surface-3': '--color-surface-3',
  // Text Colors
  'text-primary': '--color-text-primary',
  'text-secondary': '--color-text-secondary',
  'text-tertiary': '--color-text-tertiary',
  'text-button-primary': '--color-text-button-primary',
  // Overlay Colors
  'overlay-hover': '--color-overlay-hover',
  'overlay-disabled': '--color-overlay-disabled',
  'overlay-accent': '--color-overlay-accent',
  'overlay-divider': '--color-overlay-divider',
  // Misc Colors
  primary: '--color-primary',
  accent: '--color-accent',
  disabled: '--color-disabled',
  stroke: '--color-stroke',
  positive: '--color-positive',
  negative: '--color-negative',
  warning: '--color-warning',
  'positive-muted': '--color-positive-muted',
  'negative-muted': '--color-negative-muted',
  'warning-muted': '--color-warning-muted',
  // Gradient Stops
  'grad-overlay-dialog-start': '--color-grad-overlay-dialog-start',
  'grad-overlay-dialog-end': '--color-grad-overlay-dialog-end',
} as const;
